import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Toptitle from "../TopTitle";
import { MdArrowBack } from "react-icons/md";
import { Card, Col, Row, Form as MyForm } from "react-bootstrap";
import { Formik, Form } from "formik";
import { ToastContainer, toast } from "react-toastify";
import AxiosInstance from "../../utils/AxiosInstance";

export default function Settings(props) {
	const [displayRegistration, setDisplayReg] = useState(false);
	const [showAmount, setShowAmount] = useState(false);
	const [data, setData] = useState();

	const validationSchema = Yup.object({
		registraionDisplay: Yup.boolean(),
		showAmount: Yup.boolean(),
	});

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const res = await AxiosInstance({
					method: "get",
					url: `/api/v1/settings`,
				});
				setDisplayReg(res.data.data[0].registrationDisplay);
				setShowAmount(res.data.data[0].showAmount);
				setData(res.data.data[0]);
			} catch (err) {
				toast.error(err.response.message, { position: "top-center" });
			}
		};

		fetchSettings();
	}, []);
	const initialValues = {
		registrationDisplay: displayRegistration,
		showAmount: showAmount,
	};

	const onSubmit = async (values) => {
		try {
			await AxiosInstance({
				method: "patch",
				url: `/api/v1/settings/${data?._id}`,
				headers: {
					accept: "application/json",
				},
				data: values,
			});
			toast.success(`Settings of updated Successfully`);
			navigate("/admin/Settings");
		} catch (err) {
			toast.error(err.response.message, { position: "top-center" });
		}
	};

	const navigate = useNavigate();
	return (
		<>
			<div className="page-container mt-3">
				<Toptitle page="Settings" />
				<div className="content-left-side">
					<MdArrowBack
						size={40}
						color="var(--darkBlue)"
						onClick={() => navigate(-1)}
					/>
				</div>

				<h2>General Settings</h2>
				<Card>
					<Row className="p-5">
						<Formik
							enableReinitialize={true}
							initialValues={initialValues}
							validationSchema={validationSchema}
							onSubmit={async (values, { resetForm }) => {
								await onSubmit(values);
								// resetForm();
							}}
						>
							<Form>
								<div className="row mb-3">
									<ToastContainer className="top-margin" />
									<div className="col-md-6 col-sm-12">
										<MyForm.Check
											type="switch"
											id="custom-switch"
											label="Enable Only Registered Hostels"
											checked={displayRegistration}
											onChange={() => setDisplayReg(!displayRegistration)}
										/>
									</div>
									<div className="col-md-6 col-sm-12">
										<MyForm.Check
											type="switch"
											id="custom-switch"
											label="Enable Actual Hostel Prices"
											checked={showAmount}
											onChange={() => setShowAmount(!showAmount)}
										/>
									</div>
								</div>

								<button type="submit" className="btn is-primary">
									Submit
								</button>
							</Form>
						</Formik>
						<Col md="4"></Col>
					</Row>
				</Card>
			</div>
		</>
	);
}
